module.exports = __webpack_public_path__ + "img/usedGenerated2.698a3793.png";